export default __webpack_public_path__ + "static/media/emi_l.c536fb96.jpg";